import { useSelector } from 'react-redux';

import type { ConstantMenuItem } from 'app/modules/Navigation/types';
import type { ReduxState } from 'app/redux/types';

import { useFeatureFlags } from 'app/lib/feature-flags/useFeatureFlags';

type UseMenuItemsByFeatureFlagsProps = {
  fn: (pathname: string) => (state: ReduxState) => ConstantMenuItem[];
  pathname: string;
};

export const useMenuItemsByFeatureFlags = ({ fn, pathname }: UseMenuItemsByFeatureFlagsProps) => {
  const menuItems = useSelector(fn(pathname));
  const { hasFeatureFlag } = useFeatureFlags();

  const filteredItems = menuItems.filter((menuItem) => {
    const ff = menuItem.ff;

    if (ff === undefined || hasFeatureFlag(ff)) {
      return true;
    }

    return false;
  });

  return filteredItems;
};
